import React from 'react';
import { Form } from '@themesberg/react-bootstrap';
import { useTranslation } from "react-i18next";

const PenaltyChargeCell = ({ claim, penaltyCharges, setPenaltyCharges }) => {
    const { t } = useTranslation();

    return (
        <td>
            <div className="d-flex align-items-center">
                <Form.Control
                    type="number"
                    value={penaltyCharges[claim._id] || ""}
                    disabled={claim.status !== "Waiting for Admin Action"}
                    onChange={(e) => {
                        const value = e.target.value;
                        setPenaltyCharges(prev => ({
                            ...prev,
                            [claim._id]: value
                        }));
                    }}
                    className="modern-input"
                    placeholder={t("EnterPenlaty")}
                />
            </div>
        </td>
    );
};

export default PenaltyChargeCell;
